import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { FtthResourceService, Resource } from '../../../../../services/api/ftth-resource/ftth-resource.service';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, Subscription } from 'rxjs';
import { MatPaginator, MatSort, PageEvent, Sort } from '@angular/material';
import { startWith, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-cvlanspec-async-table',
  templateUrl: './cvlanspec-async-table.component.html',
  styleUrls: ['./cvlanspec-async-table.component.scss']
})
export class CVLANSpecAsyncTableComponent implements AfterViewInit, OnDestroy {

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  private _resource: Resource;

  @Input()
  get resource(): Resource {
    return this._resource;
  }

  set resource(value: Resource) {
    if (value.specificationName === 'OLTResSpec') {
      this._resource = value;
    } else {
      this._resource = undefined;
    }
  }

  @Output()
  cvlansLength = new EventEmitter<string>();

  displayedColumns: string[] = ['name', 'totalPorts', 'occupancy', 'territoryUser'];
  data: Resource[] = [];
  resultsLength = 0;

  private subscriptions = new Subscription();

  constructor(
    private ftthResourceService: FtthResourceService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
  }

  ngAfterViewInit() {
    this.subscriptions.add(
      combineLatest(
        this.sort.sortChange
          .pipe(
            startWith({
              active: this.sort.active,
              direction: this.sort.direction
            } as Sort),
            tap(() => this.paginator.firstPage()),
          ),
        this.paginator.page
          .pipe(
            startWith({
              pageIndex: this.paginator.pageIndex,
              previousPageIndex: 0,
              pageSize: this.paginator.pageSize,
              length: this.paginator.length
            } as PageEvent),
          ),
      ).pipe(
        // tslint:disable-next-line:max-line-length
        switchMap(([{active, direction}, {pageIndex, pageSize}]) => this.ftthResourceService.getCVLANPaged(this._resource.name, pageIndex, pageSize, active, direction)),
      )
      .subscribe(resourceResponse => {
        this.data = resourceResponse.resources;
        this.cvlansLength.emit(resourceResponse.page.totalElements + '');
      }));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  navigateToDetail(resource: Resource) {
    const hrefLinkChunks = resource._links.self.href.split('/');
    this.router.navigate(['..', btoa(hrefLinkChunks[hrefLinkChunks.length - 1])], { relativeTo: this.activatedRoute });
  }

}
